import React,{Component} from 'react'
import axios from 'axios/index'
import { APIURL } from '../../../config/config'

class CarLeasingForm extends Component{
  constructor (props){
    super(props)
    this.state = {
      lists: [],
      car_id : this.props.car.car_id,
      leasingName: ['SCB', 'GE', 'TA', 'KK', 'TIS'],

      SCBM: '',
      GEM: '',
      TAM: '',
      KKM: '',
      TISM: '',

      SCB: '',
      GE: '',
      TA: '',
      KK: '',
      TIS: '',

      SCB2: '',
      GE2: '',
      TA2: '',
      KK2: '',
      TIS2: '',

    }

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.loadCarLeasing();
  }

  loadCarLeasing() {
    var uri =  APIURL + '/car_leasing/'+this.state.car_id;
    axios.get(uri)
      .then(res => {
        if(res.data.length===0){
          this.setState({lists: res.data, action: 'add'})
        }else{
          this.setState({lists: res.data, action: 'edit'},()=>{
            // console.log(res.data)
            this.state.lists.map((leasing) => {
              var targetName = leasing.car_leasing_name
              var median = leasing.car_leasing_price_median
              var value = leasing.car_leasing_price
              var no_credit = leasing.car_leasing_price_nc
              if(targetName === 'SCB'){
                this.setState({SCBM: median, SCB: value, SCB2: no_credit });
              }else if(targetName === 'GE') {
                this.setState({GEM: median , GE: value , GE2: no_credit});
              }else if(targetName === 'TA'){
                this.setState({TAM: median , TA: value , TA2: no_credit});
              }else if(targetName === 'KK'){
                this.setState({KKM: median , KK: value , KK2: no_credit});
              }else if(targetName === 'TIS'){
                this.setState({TISM: median, TIS: value, TIS2: no_credit});
              }else if(targetName === 'MPRICE'){
                // this.setState({MPRICE: value});
              }
              return undefined;
            });

          })
        }

      }).catch(error => {
      this.setState({lists: []})
    })
  }

  handleChange(event) {
    var targetName = event.target.name;
    var value = event.target.value;
     //console.log(targetName);
     //console.log(value);
     // console.log(this.$ref)
    if(targetName === 'SCBM'){
      this.setState({SCBM: value });
    }else if(targetName === 'GEM') {
      this.setState({GEM: value});
    }else if(targetName === 'TAM'){
      this.setState({TAM: value});
    }else if(targetName === 'KKM'){
      this.setState({KKM: value});
    }else if(targetName === 'TISM'){
      this.setState({TISM: value});
    }

     if(targetName === 'SCB'){
       this.setState({SCB: value });
     }else if(targetName === 'GE') {
       this.setState({GE: value});
     }else if(targetName === 'TA'){
       this.setState({TA: value});
     }else if(targetName === 'KK'){
       this.setState({KK: value});
     }else if(targetName === 'TIS'){
       this.setState({TIS: value});
     }

    if(targetName === 'SCB2'){
      this.setState({SCB2: value });
    }else if(targetName === 'GE2') {
      this.setState({GE2: value});
    }else if(targetName === 'TA2'){
      this.setState({TA2: value});
    }else if(targetName === 'KK2'){
      this.setState({KK2: value});
    }else if(targetName === 'TIS2'){
      this.setState({TIS2: value});
    }

    if(targetName === 'MPRICE') {
      this.setState({MPRICE: value});
    }

  }

  render() {
    var trLeasing = ''
    if(this.state.lists.length === 0){
      trLeasing = this.state.leasingName.map((leasing, index) => {
        var input2 = '';
        var inputM = '';
        // var mprice = '';
        if(leasing==='SCB'){
          inputM = (
            <input
              className="form-control"
              type="number"
              name="SCBM"
            />
          )
          input2= ( <input
            className="form-control"
            type="number"
            name="SCB2"
          />)
        }else if(leasing==='GE'){
          inputM = (
            <input
              className="form-control"
              type="number"
              name="GEM"
            />
          )
          input2= ( <input
            className="form-control"
            type="number"
            name="GE2"
          />)
        }else if(leasing==='TA'){
          inputM = (
            <input
              className="form-control"
              type="number"
              name="TAM"
            />
          )
          input2= ( <input
            className="form-control"
            type="number"
            name="TA2"
          />)
        }else if(leasing==='KK'){
          inputM = (
            <input
              className="form-control"
              type="number"
              name="KKM"
            />
          )
          input2= ( <input
            className="form-control"
            type="number"
            name="KK2"
          />)
        }else if(leasing==='TIS'){
          inputM = (
            <input
              className="form-control"
              type="number"
              name="TISM"
            />
          )
          input2= ( <input
            className="form-control"
            type="number"
            name="TIS2"
          />)
        }
         return (
           <tr key={index}>
             <td style={{width: 100}}>{leasing}</td>
             <td style={{width: 150}}>
               {inputM}
             </td>
             <td style={{width: 150}}>
               <input
                 className="form-control"
                 type="number"
                 id={leasing}
                 name={leasing}
               />
             </td>
             <td style={{width: 150}}>
               {input2}
             </td>
           </tr>
         )
      })
    }else{

      trLeasing = this.state.lists.map((leasing, index) => {
        var mprice = '';
        var input = '';
        var input2 = '';

        if(leasing.car_leasing_name==='SCB'){

          mprice = (
            <input
              className="form-control"
              type="number"
              name="SCBM"
              value={this.state.SCBM || ''}
              onChange={this.handleChange}
            />
          )

          input= ( <input
            className="form-control"
            type="number"
            id={leasing.car_leasing_name}
            name={leasing.car_leasing_name}
            value={this.state.SCB || ''}
            onChange={this.handleChange}
          />)

          input2= ( <input
            className="form-control"
            type="number"
            name="SCB2"
            value={this.state.SCB2 || ''}
            onChange={this.handleChange}
          />)

        }else if(leasing.car_leasing_name==='GE'){
          mprice = (
            <input
              className="form-control"
              type="number"
              name="GEM"
              value={this.state.GEM || ''}
              onChange={this.handleChange}
            />
          )

          input= ( <input
            className="form-control"
            type="number"
            id={leasing.car_leasing_name}
            name={leasing.car_leasing_name}
            value={this.state.GE || ''}
            onChange={this.handleChange}
          />)

          input2= ( <input
            className="form-control"
            type="number"
            name="GE2"
            value={this.state.GE2 || ''}
            onChange={this.handleChange}
          />)

        }else if(leasing.car_leasing_name==='TA'){
          mprice = (
            <input
              className="form-control"
              type="number"
              name="TAM"
              value={this.state.TAM || ''}
              onChange={this.handleChange}
            />
          )

          input= ( <input
            className="form-control"
            type="number"
            id={leasing.car_leasing_name}
            name={leasing.car_leasing_name}
            value={this.state.TA || ''}
            onChange={this.handleChange}
          />)

          input2= ( <input
            className="form-control"
            type="number"
            name="TA2"
            value={this.state.TA2 || ''}
            onChange={this.handleChange}
          />)

        }else if(leasing.car_leasing_name==='KK'){
          mprice = (
            <input
              className="form-control"
              type="number"
              name="KKM"
              value={this.state.KKM || ''}
              onChange={this.handleChange}
            />
          )

          input= ( <input
            className="form-control"
            type="number"
            id={leasing.car_leasing_name}
            name={leasing.car_leasing_name}
            value={this.state.KK || ''}
            onChange={this.handleChange}
          />)

          input2= ( <input
            className="form-control"
            type="number"
            name="KK2"
            value={this.state.KK2 || ''}
            onChange={this.handleChange}
          />)

        }else if(leasing.car_leasing_name==='TIS'){
          mprice = (
            <input
              className="form-control"
              type="number"
              name="TISM"
              value={this.state.TISM || ''}
              onChange={this.handleChange}
            />
          )

          input= ( <input
            className="form-control"
            type="number"
            id={leasing.car_leasing_name}
            name={leasing.car_leasing_name}
            value={this.state.TIS || ''}
            onChange={this.handleChange}
          />)

          input2= ( <input
            className="form-control"
            type="number"
            name="TIS2"
            value={this.state.TIS2 || ''}
            onChange={this.handleChange}
          />)
        }

        if(leasing.car_leasing_name!=='MPRICE') {

          return (
            <tr key={index}>
              <td style={{width: 100}}>{leasing.car_leasing_name}</td>
              <td style={{width: 150}}>
                {mprice}
              </td>
              <td style={{width: 150}}>
                {input}
              </td>
              <td style={{width: 150}}>
                {input2}
              </td>
            </tr>
          )
        }else{
          return null;
        }

      })

      /*if(mprice === ''){
        var index = 99
        mprice = (
          <tr key={index}>
            <td style={{width: 100}}>ราคากลาง</td>
            <td colSpan={2} style={{width: 300}}>
              <input
                className="form-control"
                type="number"
                name="MPRICE"
                value={this.state.MPRICE}
                onChange={this.handleChange}
              />
            </td>
          </tr>)
      }*/

    }

    return (
      <div className="card card-accent-primary">
        <form action="" method="post" onSubmit={this.props.onSubmit}>
          <div className="card-header">
            <strong>บันทึกยอดจัด</strong>
          </div>
          <div className="card-block">
            <div className="row text-center">
              <table className="tableWhitesmoke" style={{marginTop: 8}}>
                <thead>
                  <tr>
                    <th className="text-center" >ลิสซิ่ง</th>
                    <th className="text-center" >ราคากลาง</th>
                    <th className="text-center" >เครดิต</th>
                    <th className="text-center" >ไม่เครดิต</th>
                  </tr>
                </thead>
                <tbody>
                {trLeasing}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card-footer text-right">
            <button type="reset"
                    onClick={this.props.onHandle.cancel}
                    className="btn btn-sm btn-danger">
              <i className="fa fa-refresh"></i> ยกเลิก
            </button>

            <button type="submit" className={this.state.action==='add'? "btn btn-sm btn-primary" : "btn btn-sm btn-warning" }>
              <i className="fa fa-save"></i>
               {this.state.action==='add'? " บันทึก" : " แก้ไข" }
            </button>
            <input type="hidden" name="action" defaultValue={this.state.action}  />
          </div>
        </form>
      </div>
    )
  }
}

export default CarLeasingForm
